import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { pca } from "../auth/authConfig";

export const getAccessToken = async (): Promise<string | undefined> => {
  let account = pca.getActiveAccount();
  if (!account) {
    account = pca.getAllAccounts()[0];
  }

  if (account) {
    return pca
      .acquireTokenSilent({
        scopes: ["api://" + import.meta.env.VITE_API_CLIENT_ID + "/access_as_user"],
        account: account,
      })
      .then((response) => {
        if (response) {
          return response.accessToken;
        }
      });
  }
};

export const combinedApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URL,
    prepareHeaders: async (headers) => {
      const accessToken = await getAccessToken();
      if (accessToken) {
        headers.set("Authorization", "Bearer " + accessToken);
      }
      headers.set("content-type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  invalidationBehavior: "immediately",
});

// activeMeasuringPointApi.enhanceEndpoints({
//   addTagTypes: ["MeasuringPoint", "Device", "Router"],
//   endpoints: {
//     putActiveMeasuringPointByName: { invalidatesTags: ["MeasuringPoint", "Device", "Router"] },
//     deleteActiveMeasuringPointByName: { invalidatesTags: ["MeasuringPoint", "Device", "Router"] },
//   },
// });
